/** @jsx h */
/** @jsxFrag Fragment */

import { h, Fragment, ComponentProps } from "preact";
import { LoadingIndicator } from "./common";

export type ButtonProps = {
  onClick: () => void;
  loading?: boolean;
} & ComponentProps<any>;

export const PrimaryButton = ({
  onClick,
  children,
  className,
  disabled,
  loading,
}: ButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={`lx-button lx-button-primary ${className}`}
      disabled={disabled}
    >
      <div className="lx-button-inner lx-button-primary-inner">
        {loading ? <LoadingIndicator /> : children}
      </div>
    </button>
  );
};

export const SecondaryButton = ({
  onClick,
  children,
  className,
}: ButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={`lx-button lx-button-secondary ${className}`}
    >
      <div className="lx-button-inner lx-button-secondary-inner">
        {children}
      </div>
    </button>
  );
};
